module.exports = __webpack_public_path__ + "system/img/defd-da.58c2494b.png";